<template>
  <div>
    <v-dialog v-model="model" max-width="800" persistent scrollable>
      <employer-notes-form
        v-if="model"
        :title="$t('components.memberview.add_note_{0}', [name])"
        :note="note"
        @close="$emit('close')"
      />
    </v-dialog>
  </div>
</template>

<script>
// import { mapActions, mapGetters } from "vuex";
import EmployerNotesForm from "@/components/Employers/EmployerNotesForm.vue";
// import EmployerNotesTable from "../components/MemberNotesTable.vue";

export default {
  components: {
    EmployerNotesForm
  },
  props: ["model", "id", "name", "note"],
  data() {
    return {
    };
  },
  computed: {
    // ...mapGetters("common", { selectedPlan: "plan" }),
    // ...mapGetters("plansMembers", ["options", "planOptions", "planIdentity"]),
    // ...mapGetters("common", ["language"]),
  },
  watch: {
    // model: {
    //   handler(v) {
    //     if (v) {
    //       this.loadItem();
    //     }
    //   },
    // },
  },
  methods: {
    // ...mapActions("plansMembers", ["getEmployerForLogo", "updateEmployerLogo"]),    
  },
};
</script>
